import React, { Component } from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { Div } from "components/Base";
import { MODES } from "../../../constants";
import * as R from "ramda";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getters } from "SendEmailModal/model";
import * as SEND_TO_OPTION_TYPES from "SendEmailModal/utils/send-to-option-types";
@CSSModules(css)
class Confirm extends Component {
  render() {
    const validFilter =
      this.props.mode === MODES.SMS
        ? r => r.meta.hasValidPhone
        : r => r.meta.hasValidEmail;
    const selectedContacts =
      R.filter(
        contact => contact.selected,
        this.props.particularContactsSelected
      ) ?? [];
    const validRecipients =
      SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS !==
      this.props.selectedOptions
        ? this.props.recipients.filter(validFilter)
        : R.filter(
            contact =>
              selectedContacts.some(selectedContact => {
                return contact.meta.id === selectedContact.id;
              }),
            this.props.recipients.filter(validFilter)
          );
    return (
      <div styleName="checkWrapper">
        <div styleName="checkIcon">
          <i className="material-icons">send</i>
        </div>
        <Div display="column.center">
          <Div display="row.center" fw={3} mt={3} mb={3}>
            Just to confirm - You're about to send {validRecipients.length}{" "}
            {this.props.mode === MODES.SMS
              ? validRecipients.length === 1
                ? "message"
                : "messages"
              : validRecipients.length === 1
              ? "email"
              : "emails"}
            .
          </Div>
          <Div display="row.center" mb={3}>
            Ready to go? Hit "Send" below.
          </Div>
        </Div>
        <Div
          onClick={this.props.sending ? undefined : this.props.onConfirm}
          bra={1}
          p={3}
          fs={3}
          fw={3}
          color="white"
          bg="success7"
        >
          {this.props.sending ? (
            "Sending..."
          ) : (
            <span>
              Send {validRecipients.length}{" "}
              {this.props.mode === MODES.SMS
                ? validRecipients.length === 1
                  ? "message"
                  : "messages"
                : validRecipients.length === 1
                ? "email"
                : "emails"}
            </span>
          )}
        </Div>
      </div>
    );
  }
}

const decorate = R.compose(
  withRouter,
  connect(
    state => ({
      selectedOptions: getters.selectedOptions(state),
      particularContactsSelected: getters.particularContactsSelected(state)
    }),
    {}
  )
);

export default decorate(Confirm);
